if (!customElements.get('quantity-calculator')) {
  class QuantityCalculator extends HTMLElement {
    constructor() {
      super();

      this.minimumQuantity = this.dataset.minimumQuantity
        ? Number(this.dataset.minimumQuantity)
        : 0;
      this.minimumQuantityPrice = this.dataset.minimumQuantityPrice
        ? Number(this.dataset.minimumQuantityPrice)
        : 0;
      this.tieredPrices = this.getTieredPrices(
        this.dataset.tieredPrices,
        this.minimumQuantity,
        this.minimumQuantityPrice
      );
      this.plantingDistance = this.dataset.plantingDistance
        ? Number(this.dataset.plantingDistance)
        : 1;

      this.unitInput = this.querySelector('input[name="unit"]');
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.priceElement = this.querySelector('[data-price]');
      this.invalidMessage = this.querySelector('[data-invalid-message]');

      if (!this.quantityInput || !this.priceElement) return;

      this.quantity = isNaN(this.quantityInput.valueAsNumber)
        ? this.minimumQuantity || 1
        : this.quantityInput.valueAsNumber;
      this.unit =
        this.unitInput && !isNaN(this.unitInput.valueAsNumber) ? this.unitInput.valueAsNumber : 0;
      this.isUpdating = false;

      this.productFormQuantity = document.querySelector('product-form input[name="quantity"]');

      this.quantityInput.addEventListener('input', () => this.onQuantityChanged());
      this.unitInput?.addEventListener('input', () => this.onUnitChanged());

      this.setupVariantUpdateListener();
      this.update();
    }

    getTieredPrices(dataSet, minimumQuantity = 1, minimumQuantityPrice = 0) {
      const tieredPrices = dataSet && dataSet != 'null' ? JSON.parse(dataSet) : [];

      if (!tieredPrices.length || minimumQuantity < tieredPrices[0][0]) {
        tieredPrices.push([minimumQuantity, minimumQuantityPrice]);
      }

      tieredPrices.sort((a, b) => a[0] - b[0]);

      return tieredPrices;
    }

    onQuantityChanged() {
      if (this.isUpdating) return;

      const value = this.quantityInput.valueAsNumber;
      if (isNaN(value)) return;

      this.quantity = Math.round(value);
      this.unit = parseFloat((value * this.plantingDistance).toFixed(2));

      this.update();
    }

    onUnitChanged() {
      if (this.isUpdating) return;

      const value = this.unitInput.valueAsNumber;
      if (isNaN(value)) return;

      this.quantity = Math.round(value / this.plantingDistance);
      this.unit = parseFloat(value.toFixed(2));

      this.update();
    }

    handleValidationMessage() {
      if (!this.invalidMessage) return;

      const value = this.quantity;
      const message = this.invalidMessage.dataset.message || this.invalidMessage.textContent;
      this.invalidMessage.textContent = message.replace('{0}', value);
    }

    update() {
      if (!this.quantityInput) {
        return;
      }

      this.isUpdating = true;
      this.quantityInput.value = this.quantity;

      if (this.unitInput && this.unit !== undefined) {
        this.unitInput.value = this.unit;
      }
      this.isUpdating = false;

      const isValid =
        this.quantityInput.checkValidity() && this.quantity >= (this.minimumQuantity || 1);

      if (this.invalidMessage) {
        if (isValid) {
          this.invalidMessage.classList.add('hidden');
        } else {
          this.invalidMessage.classList.remove('hidden');
          this.handleValidationMessage();
        }
      }

      if (!isValid) {
        return;
      }

      if (this.productFormQuantity) {
        this.productFormQuantity.value = this.quantity;
      }

      const price = this.calculatePrice();
      if (price) {
        this.priceElement.textContent = price;
      } else {
        if (this.invalidMessage) {
          this.invalidMessage.classList.remove('hidden');
        }
      }

      this.notifyCrossSellComponents();
    }

    calculatePrice(tieredPrices = this.tieredPrices, quantity = this.quantity) {
      if (!tieredPrices.length) {
        return;
      }

      const tier = tieredPrices.findLast((tier) => quantity >= tier[0]);

      if (!tier) {
        return;
      }

      const totalPrice = quantity * tier[1];
      const formattedPrice = (totalPrice / 100).toFixed(2).replace('.', ',');

      return formattedPrice;
    }

    notifyCrossSellComponents() {
      // Simply trigger cross-sell components to update themselves
      document.querySelectorAll('cross-sell').forEach((crossSell) => {
        if (crossSell.updateQuantityAndPrice) {
          crossSell.updateQuantityAndPrice();
        }
      });
    }

    setupVariantUpdateListener() {
      document.addEventListener('variant-sections-updated', () => {
        setTimeout(() => {
          this.reinitializeAfterVariantUpdate();
        }, 50);
      });
    }

    reinitializeAfterVariantUpdate() {
      // Re-establish references after DOM update
      this.productFormQuantity = document.querySelector('product-form input[name="quantity"]');

      // Update tiered prices from new dataset
      this.minimumQuantity = this.dataset.minimumQuantity
        ? Number(this.dataset.minimumQuantity)
        : 0;
      this.minimumQuantityPrice = this.dataset.minimumQuantityPrice
        ? Number(this.dataset.minimumQuantityPrice)
        : 0;
      this.tieredPrices = this.getTieredPrices(
        this.dataset.tieredPrices,
        this.minimumQuantity,
        this.minimumQuantityPrice
      );
      this.plantingDistance = this.dataset.plantingDistance
        ? Number(this.dataset.plantingDistance)
        : 1;

      // Re-establish element references
      this.unitInput = this.querySelector('input[name="unit"]');
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.priceElement = this.querySelector('[data-price]');
      this.invalidMessage = this.querySelector('[data-invalid-message]');

      if (this.quantityInput && this.priceElement) {
        // Preserve current quantity if valid, otherwise use minimum
        const currentQuantity = isNaN(this.quantityInput.valueAsNumber)
          ? this.minimumQuantity || 1
          : this.quantityInput.valueAsNumber;
        this.quantity = Math.max(currentQuantity, this.minimumQuantity || 1);
        this.unit =
          this.unitInput && !isNaN(this.unitInput.valueAsNumber)
            ? this.unitInput.valueAsNumber
            : this.quantity * this.plantingDistance;
        this.isUpdating = false;

        this.update();
      }
    }

    getBulkprices() {
      return this.tieredPrices;
    }
  }

  customElements.define('quantity-calculator', QuantityCalculator);
}
